module.exports = __webpack_public_path__ + "img/img6.e3dc1a2f.png";